// ========================================
// 📄 src/components/interactions/InteractionList.jsx
// ========================================
import React from "react";
import { useInteractions } from "../../hooks/useInteractions";
import LoadingSpinner from "../common/LoadingSpinner";

const InteractionList = ({ leadId }) => {
  const { interactions, loading, error } = useInteractions(leadId);

  if (!leadId) return null;

  if (loading) {
    return (
      <div className="py-4">
        <LoadingSpinner size="sm" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 text-red-700 px-3 py-2 rounded">{error}</div>
    );
  }

  if (!interactions || interactions.length === 0) {
    return <div className="text-sm text-gray-500">Aucune interaction.</div>;
  }

  return (
    <ul className="space-y-3">
      {interactions.map((it) => (
        <li
          key={it.id}
          className="p-3 bg-white rounded-lg border shadow-sm flex items-start justify-between"
        >
          <div>
            <div className="text-sm font-semibold text-gray-800">
              {it.type} — {it.sentiment}
            </div>
            {it.notes && (
              <div className="text-sm text-gray-600 mt-1 whitespace-pre-wrap">
                {it.notes}
              </div>
            )}
          </div>
          <div className="text-xs text-gray-400">
            {it.createdAt?.toDate?.()
              ? it.createdAt.toDate().toLocaleString()
              : ""}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default InteractionList;
